import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Title from "../Title/Title";
import "swiper/css";
import "swiper/css/navigation";
import "./Brands.css";

export default function Brands({ brands }) {
  const hasTwoRows = brands.length > 6;
  const half = Math.ceil(brands.length / 2);
  const firstRow = hasTwoRows ? brands.slice(0, half) : brands;
  const secondRow = hasTwoRows ? brands.slice(half) : [];

  return (
    <div >

      <Title title='Our Brands' />

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={6}
        loop={true}
        speed={6000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        allowTouchMove={false}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 3, spaceBetween: 15 },
          1024: { slidesPerView: 5, spaceBetween: 20 },
          1280: { slidesPerView: 6, spaceBetween: 25 },
        }}
        className="brands-swiper"
      >
        {firstRow.map((brand, idx) => (
          <SwiperSlide key={idx}>
            <Link to={`/brand/${brand.slug}`}>
              <div className="brand-card">
                <img src={brand.image} alt={brand.name} />
              </div>
            </Link>
          </SwiperSlide>
        ))}

      </Swiper>

      {/* Row 2 – scrolls right (reverse) */}
      {hasTwoRows && (
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={6}
          loop={true}
          speed={6000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
          }}
          allowTouchMove={false}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            640: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 5, spaceBetween: 20 },
            1280: { slidesPerView: 6, spaceBetween: 25 },
          }}
          className="brands-swiper reverse"
        >
          {secondRow.map((brand, idx) => (
            <SwiperSlide key={idx}>
              <Link to={`/brand/${brand.slug}`}>
                <div className="brand-card">
                  <img src={brand} alt={`Brand ${idx + 1}`} />
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}